module.exports = __webpack_public_path__ + "img/dice-5.3a9ec283.svg";